<div class="wrapper">
  <div class="display-button-container on-mobile-hidden">
    <div class="minimize-container" (click)="toggleMinimize()">
      <mat-icon>{{ minimized ? 'arrow_forward' : 'arrow_back' }}</mat-icon>
      @if (!minimized) {
        <span>{{ 'sideMenu.minimize' | translate }}</span>
      }
    </div>

    @if (!minimized) {
      <mat-icon (click)="close()">close</mat-icon>
    }
  </div>

  <div class="main">
    <div class="user-name-container">
      @if (currentUser && !minimized) {
        <span class="user-name">{{ currentUser.displayName }}</span>
      }
    </div>
    <nav class="link-container">
      <div class="navigation-links">
        <app-side-menu-button
          class="on-mobile-hidden"
          link="/"
          icon="dashboard"
          [title]="'home.TITLE' | translate">
        </app-side-menu-button>
        <app-side-menu-button
          *appWithPermission="'REPORTING'"
          class="on-mobile-only"
          link="orders"
          icon="science"
          [exact]="false"
          [title]="'Your Labs'">
        </app-side-menu-button>
        <app-side-menu-button
          *appWithPermission="['REPORTING', 'CALCULATIONS', 'ORDERS', 'DEFERRED_SAMPLES', 'BILLS']"
          class="on-mobile-hidden"
          link="orders"
          icon="science"
          [exact]="false"
          [title]="'Your Labs'">
        </app-side-menu-button>
        <app-side-menu-button
          *appWithPermission="'UPLOAD'"
          class="on-mobile-hidden"
          link="upload"
          icon="upload"
          [title]="'upload.TITLE_NAV' | translate">
        </app-side-menu-button>
        <app-side-menu-button
          *appWithPermission="'LOGISTICS'"
          class="on-mobile-hidden"
          link="logistics"
          icon="local_shipping"
          [title]="'logistics.TITLE_NAV' | translate">
        </app-side-menu-button>
        @if (currentUser?.mayUsePriceList) {
          <app-side-menu-button
            class="on-mobile-hidden"
            link="prices"
            icon="monetization_on"
            [title]="'prices.TITLE_NAV' | translate">
          </app-side-menu-button>
        }
        @if (currentUser?.hasSubUsers) {
          <app-side-menu-button
            class="on-mobile-hidden"
            link="team"
            icon="groups"
            [title]="'authorisations.navTitle' | translate">
          </app-side-menu-button>
        }
        <app-side-menu-button
          class="on-mobile-hidden"
          link="configuration"
          icon="settings"
          [title]="'config.TITLE' | translate">
        </app-side-menu-button>
      </div>
    </nav>
    <div class="link-container__end">
      <app-side-menu-button
        class="on-mobile-hidden"
        icon="textsms"
        [title]="'common.CONTACT' | translate"
        (click)="openContactDialog()">
      </app-side-menu-button>
      <app-side-menu-button
        icon="info_i"
        [title]="'sideMenu.imprint' | translate"
        (click)="openImprint()">
      </app-side-menu-button>
      <app-side-menu-button
        icon="logout"
        [title]="'login.NAV_LOGOUT' | translate"
        (click)="logout()">
      </app-side-menu-button>
    </div>
  </div>
</div>
